import { render, staticRenderFns } from "./InformacionPacienteView.vue?vue&type=template&id=4d8e7b82"
import script from "./InformacionPacienteView.vue?vue&type=script&lang=ts"
export * from "./InformacionPacienteView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports